module.exports = __webpack_public_path__ + "static/media/attr_opd.d1bab2e4.svg";